<div class="erut-upload-step">
  <p class="main-question"><strong>Carga el e-RUT de la empresa</strong></p>
  <p class="subtext">
    Es la Cedula RUT Electronica que emite el SII. Sube el archivo PDF tal como lo
    descargas, sin abrirlo ni volver a guardarlo.
  </p>

  <!-- ==================== SELECCION ==================== -->
  <ng-container *ngIf="status === 'idle'">
    <label class="dropzone" for="erut-file">
      <mat-icon>picture_as_pdf</mat-icon>
      <span class="dropzone-title">Seleccionar el PDF del e-RUT</span>
      <span class="dropzone-hint">Solo PDF, hasta 10 MB</span>
      <input
        type="file"
        id="erut-file"
        accept="application/pdf,.pdf"
        (change)="onFileSelected($event)"
      />
    </label>

    <div class="info-box">
      <div class="info-header">
        <mat-icon>info</mat-icon>
        <span class="info-title">Como obtener el e-RUT</span>
      </div>
      <p class="info-text">
        Ingresa a sii.cl con la clave tributaria de la empresa y descarga la Cedula
        RUT Electronica. El PDF trae un codigo QR que usamos para verificar que el
        documento no fue alterado.
      </p>
    </div>
  </ng-container>

  <!-- ==================== ARCHIVO ELEGIDO ==================== -->
  <ng-container *ngIf="status === 'selected'">
    <div class="file-card">
      <mat-icon class="file-icon">picture_as_pdf</mat-icon>
      <div class="file-info">
        <span class="file-name">{{ selectedFile?.name }}</span>
        <span class="file-size">{{ fileSizeLabel }}</span>
      </div>
      <button type="button" class="icon-btn" (click)="clearFile()" title="Quitar archivo">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="actions">
      <button type="button" class="continue-btn" (click)="analyze()">
        Verificar e-RUT
      </button>
      <button type="button" class="back-btn" (click)="goBack()">Volver</button>
    </div>
  </ng-container>

  <!-- ==================== ANALIZANDO ==================== -->
  <ng-container *ngIf="status === 'analyzing'">
    <div class="analyzing">
      <div class="spinner"></div>
      <p class="analyzing-text">Verificando el documento...</p>
      <p class="analyzing-hint">Leemos los datos y revisamos el codigo QR.</p>
    </div>
  </ng-container>

  <!-- ==================== ACEPTADO / REVISION ==================== -->
  <ng-container *ngIf="status === 'accepted' || status === 'review'">
    <div class="result-banner" [class.warning]="status === 'review'">
      <mat-icon>{{ status === 'review' ? 'schedule' : 'check_circle' }}</mat-icon>
      <div class="result-text">
        <span class="result-title">
          {{ status === 'review' ? 'Quedara en revision manual' : 'Documento verificado' }}
        </span>
        <span class="result-desc">
          {{
            status === 'review'
              ? 'Recibimos el e-RUT, pero necesita que lo revise nuestro equipo antes de aprobarlo.'
              : 'No encontramos señales de alteracion en el documento.'
          }}
        </span>
      </div>
    </div>

    <!-- Datos de la empresa -->
    <div class="fields-card">
      <p class="fields-title">Datos de la empresa</p>

      <div class="field-row">
        <span class="field-label">RUT</span>
        <span class="field-value">{{ analysis?.fields?.rut || '—' }}</span>
      </div>
      <div class="field-row">
        <span class="field-label">Razon social</span>
        <span class="field-value">{{ analysis?.fields?.razonSocial || '—' }}</span>
      </div>
      <div class="field-row">
        <span class="field-label">Direccion</span>
        <span class="field-value">{{ analysis?.fields?.direccion || '—' }}</span>
      </div>
      <div class="field-row">
        <span class="field-label">N° de serie</span>
        <span class="field-value">{{ analysis?.fields?.serie || '—' }}</span>
      </div>

      <p class="fields-note">
        <mat-icon>qr_code_2</mat-icon>
        Estos cuatro datos coinciden con el codigo QR del documento.
      </p>

      <ng-container *ngIf="analysis?.fields?.glosaActividad || analysis?.fields?.fechaEmision">
        <div class="field-row" *ngIf="analysis?.fields?.glosaActividad">
          <span class="field-label">Actividad</span>
          <span class="field-value">{{ analysis?.fields?.glosaActividad }}</span>
        </div>
        <div class="field-row" *ngIf="analysis?.fields?.fechaEmision">
          <span class="field-label">Emision</span>
          <span class="field-value">{{ analysis?.fields?.fechaEmision }}</span>
        </div>
      </ng-container>
    </div>

    <div class="actions">
      <button type="button" class="continue-btn" (click)="continue()">Continuar</button>
      <button type="button" class="back-btn" (click)="clearFile()">
        Cargar otro documento
      </button>
    </div>
  </ng-container>

  <!-- ==================== RECHAZADO ==================== -->
  <ng-container *ngIf="status === 'rejected'">
    <div class="result-banner error">
      <mat-icon>error_outline</mat-icon>
      <div class="result-text">
        <span class="result-title">No podemos aceptar este documento</span>
        <span class="result-desc">
          Descarga el e-RUT nuevamente desde sii.cl y subelo sin volver a guardarlo.
        </span>
      </div>
    </div>

    <div class="reasons-card" *ngIf="rejectionReasons.length">
      <p class="reasons-title">Que encontramos</p>
      <ul>
        <li *ngFor="let reason of rejectionReasons">{{ reason }}</li>
      </ul>
    </div>

    <div class="actions">
      <button type="button" class="continue-btn" (click)="clearFile()">
        Cargar otro documento
      </button>
      <button type="button" class="back-btn" (click)="goBack()">Volver</button>
    </div>
  </ng-container>

  <!-- ==================== EMPRESA YA REGISTRADA ==================== -->
  <ng-container *ngIf="status === 'duplicada'">
    <div class="result-banner error">
      <mat-icon>error_outline</mat-icon>
      <div class="result-text">
        <span class="result-title">Esta empresa ya está registrada</span>
        <span class="result-desc">
          El RUT del e-RUT que subiste ya está registrado en Aguacate.
          Si la empresa ya tiene una cuenta, inicia sesión con ella o pide acceso
          a quien la registró. Si no la reconoces, escríbenos a soporte.
        </span>
      </div>
    </div>

    <div class="actions">
      <button type="button" class="continue-btn" (click)="clearFile()">
        Cargar otro documento
      </button>
      <button type="button" class="back-btn" (click)="goBack()">Volver</button>
    </div>
  </ng-container>
</div>
